<template>
  <div>
    <b-modal
      v-model="show"
      hide-footer
      dialog-class="discovery-join-modal"
      content-class="discovery-join-model-content"
      body-class="discovery-join-model-body"
    >
      <b-container fluid>
        <b-row>
          <b-col class="left-side">
            <b-container fluid >
              <b-row>
                <b-col>
                    
                    <h3>
                    Find your ideal bank account in 60 seconds 
                        </h3> 
                    </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <p>
                    Call us on 0800 07 96 97 or fill in some quick details and
                    find the ideal bank account to suit your needs
                  </p>
                </b-col>
              </b-row>
              <b-row class='form-bg p-3'>
                <b-col>
                  <p>I am looking for:</p>
                  <b-form-checkbox-group
                    v-model="selected"
                    :options="looking"
                    class="mb-3"
                    value-field="value"
                    text-field="text"
                    stacked
                  ></b-form-checkbox-group>
                  <b-button>
                      GET STARTED
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col></b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      selected: [],
      looking: [
        { value: "The best rewards", text: "The best rewards" },
        {
          value: "Credit with a dymanic borrowing rate",
          text: "Credit with a dymanic borrowing rate",
        },
        {
          value: "Maximum returns on my savings",
          text: "Maximum returns on my savings",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.left-side{
    background-color:#f5f5f5;
    padding:5rem;
}
.form-bg{
    background-color:white;
}
</style>